import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { getBillingInvoiceDetails } from "../api/getBillingInvoiceDetails/getBillingInvoiceDetailsApi";
import { BillingInvoiceDetails } from "../api/getBillingInvoiceDetails/types";

export function useBillingInvoiceDrawer() {
  const [invoiceId, setInvoiceId] = useState<string | null>(null);
  const [invoice, setInvoice] = useState<BillingInvoiceDetails | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!invoiceId) return;

    const controller = new AbortController();
    setInvoice(null);

    getBillingInvoiceDetails(invoiceId, controller.signal)
      .then((response) => {
        setInvoice(response.data);
        setLoading(false);
      })
      .catch((error) => {
        if (!axios.isCancel(error)) setLoading(false);
      });

    return () => controller.abort();
  }, [invoiceId]);

  const openInvoice = useCallback((id: string) => {
    setInvoiceId(id);
    setLoading(true);
  }, []);

  const closeInvoice = useCallback(() => setInvoiceId(null), []);

  return {
    isOpen: invoiceId !== null,
    invoice,
    loading,
    openInvoice,
    closeInvoice,
  };
}
